// extracted by mini-css-extract-plugin
export default {"PriceListAndMap":"pPZ2j_MI"};